import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { MiniQuestionnaireData } from "@/types/miniQuestionnaire";

interface MiniSection4Props {
  data: MiniQuestionnaireData;
  updateData: (field: keyof MiniQuestionnaireData, value: string) => void;
}

const MiniSection4 = ({ data, updateData }: MiniSection4Props) => {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-semibold text-feel-foreground mb-6">
        Section IV – Alcool
      </h2>

      {/* Question 8 - Fréquence alcool */}
      <div className="space-y-3">
        <Label className="text-lg font-medium text-feel-foreground">
          Q8. À quelle fréquence consommez‑vous de l'alcool (bière, vin, spiritueux) ?
        </Label>
        <RadioGroup
          value={data.frequence_alcool}
          onValueChange={(value) => updateData("frequence_alcool", value)}
          className="space-y-2"
        >
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="jamais_rarement" id="alcool-jamais" />
            <Label htmlFor="alcool-jamais" className="cursor-pointer">Je ne bois jamais ou rarement</Label>
          </div>
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="occasionnellement" id="alcool-occasionnel" />
            <Label htmlFor="alcool-occasionnel" className="cursor-pointer">Occasionnellement, je bois 1 à 2 fois par semaine</Label>
          </div>
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="regulierement" id="alcool-regulier" />
            <Label htmlFor="alcool-regulier" className="cursor-pointer">Régulièrement, je bois presque tous les jours</Label>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};

export default MiniSection4;
